import {
  FETCH_MAIL_PIECES_DETAILED_COUNT,
  FETCH_MAIL_PIECES_TOTAL,
  RESET_DASHBOARD,
  SET_DATES,
  SET_TEMPLATE_FILTER,
  SET_QUICK_FILTER,
  FILTER_TEMPLATES
} from "./types";
import * as dashboardApi from "@/api-client/dashboard";
import * as templateApi from "@/api-client/template";
import * as leterTemplateApi from "@/api-client/letters";

export default {
  async fetchMailPiecesDetailedCount({ commit }, data) {
    const { initial, ...rest } = data;

    commit({
      type: FETCH_MAIL_PIECES_DETAILED_COUNT.request,
      payload: { initial }
    });

    try {
      const resp = await dashboardApi.fetchMailPiecesDetailedCount(rest);

      /*for debug */
      // resp.items.splice(0, 1, {
      //   date: "2020-07-14",
      //   details: [{ count: 20, type: "postcard-6x9-usps-first-class" }],
      //   total: 20,
      //   total_cost: 48
      // });
      // console.log(resp);
      commit({
        type: FETCH_MAIL_PIECES_DETAILED_COUNT.success,
        payload: {
          data: resp,
          initial
        }
      });
    } catch (e) {
      commit({
        type: FETCH_MAIL_PIECES_DETAILED_COUNT.error,
        error: e.message
      });
    }
  },

  async fetchMailPiecesTotal({ commit }) {
    commit({
      type: FETCH_MAIL_PIECES_TOTAL.request
    });

    try {
      const resp = await dashboardApi.fetchMailPiecesDetailedCount();
      commit({
        type: FETCH_MAIL_PIECES_TOTAL.success,
        payload: resp
      });
    } catch (e) {
      commit({
        type: FETCH_MAIL_PIECES_TOTAL.error,
        error: e.message
      });
    }
  },

  async filterTemplates(
    { commit, dispatch },
    {
      page = 1,
      sorting = { key: "updated_at", value: false },
      limit = 100,
      search
    } = {}
  ) {
    commit({
      type: FILTER_TEMPLATES.request
    });

    try {
      const resp = await templateApi.fetchTemplatesList({
        sorting,
        page,
        page_size: limit,
        search
      });

      dispatch(
        "lettersTemplates/fetchLettersTemplatesList",
        {
          sorting,
          page,
          page_size: limit,
          search
        },
        { root: true }
      );

      commit({
        type: FILTER_TEMPLATES.success,
        payload: resp
      });
    } catch (e) {
      commit({
        type: FILTER_TEMPLATES.error,
        error: e.message
      });
    }
  },

  resetDashboard({ commit }) {
    commit({ type: RESET_DASHBOARD });
  },

  setDates({ commit }, { start, end } = {}) {
    commit({
      type: SET_DATES,
      payload: {
        start,
        end
      }
    });
  },

  setTemplateFilter(
    { commit },
    { value, filterType = "sizes", templateType = "postcard" }
  ) {
    commit({
      type: SET_TEMPLATE_FILTER,
      payload: {
        filterType,
        templateType,
        value
      }
    });
  },

  setQuickFilter({ commit }, type) {
    commit({
      type: SET_QUICK_FILTER,
      payload: type
    });
  }
};
